import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { RepairAppointment } from '@app/shared/models/RepairAppointment.model';

@Injectable({
    providedIn: 'root'
})
export class EventsService {
    constructor(private configService: ConfigurationService, private http: HttpClient) { }

    getRepairAppointments(userId: string, tenancyReference: string) {
        const repairsApiUrl = this.configService.getConfig()?.shell.api.repairsApiUrl;
        return this.http.get<RepairAppointment[]>(
            `${repairsApiUrl}repairAppointments?userId=${userId}&tenancyReference=${tenancyReference}`
        );
    }
}
